const RESPONSE_TYPE = "code";
const RESPONSE_MODE = "query";

const OPEN_ID_REDIRECT_URI = process.env.REACT_APP_OPEN_ID_REDIRECT_URI_PATH;

type OidcLoginOptions = {
  clientId?: string;
  authorizationEndpoint?: string;
  scope: string;
  useResponseMode?: boolean;
};

const loginWithOidcProvider = ({
  clientId,
  authorizationEndpoint,
  scope,
  useResponseMode = false,
}: OidcLoginOptions) => {
  if (clientId == null || authorizationEndpoint == null || OPEN_ID_REDIRECT_URI == null) {
    throw new Error("Missing required OpenId configuration.");
  }

  const protocol = window.location.protocol;
  const host = window.location.host;
  const redirectUri = `${protocol}//${host}${OPEN_ID_REDIRECT_URI}`;

  const queryParams = new URLSearchParams({
    client_id: clientId,
    response_type: RESPONSE_TYPE,
    scope,
    redirect_uri: redirectUri,
  });

  if (useResponseMode) {
    queryParams.set("response_mode", RESPONSE_MODE);
  }

  const redirectUrl = `${authorizationEndpoint}?${queryParams.toString()}`;

  window.location.href = redirectUrl;
};

export const loginWithEntra = () => {
  const entraScope = process.env.REACT_APP_ENTRA_SCOPE;

  if (entraScope == null) throw new Error("Missing Entra scope configuration.");

  loginWithOidcProvider({
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID,
    authorizationEndpoint: process.env.REACT_APP_ENTRA_AUTHORIZATION_ENDPOINT,
    useResponseMode: true,
    scope: entraScope,
  });
};

export const loginWithOpenId = () => {
  const openIdScope = process.env.REACT_APP_OPEN_ID_SCOPE;

  if (openIdScope == null) throw new Error("Missing required OpenId scope configuration.");

  loginWithOidcProvider({
    clientId: process.env.REACT_APP_OPEN_ID_CLIENT_ID,
    authorizationEndpoint: process.env.REACT_APP_OPEN_ID_AUTHORIZATION_ENDPOINT,
    scope: openIdScope,
  });
};
